import { useDataFetch, Indicator } from '../providers/DataFetch.provider';

const useDataFetchIndicator = (): [
  [boolean, string?, Indicator?, boolean?],
  (isFetching: boolean, msg?: string, indicator?: Indicator, isDataFetchingStickey?: boolean) => void,
] => {
  const { isDataFetching, loadingMessage, indicator, isDataFetchingStickey, setDataFetchingInfo } = useDataFetch();

  return [[isDataFetching, loadingMessage, indicator, isDataFetchingStickey], setDataFetchingInfo];
};

export default useDataFetchIndicator;
